import { render, staticRenderFns } from "./MerchantBusinessAddressManagement.vue?vue&type=template&id=3608b211&"
import script from "./MerchantBusinessAddressManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantBusinessAddressManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBusinessAddressManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports